// src/redux/api/expenses.js
import dayjs from "dayjs";
import { apiSlice } from ".";
import { toast } from "react-toastify";

const expensesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getExpenseTypes: builder.query({
      query: () => ({
        url: "/Expenses/GetExpensesTypes",
        method: "GET",
      }),
    }),

    postExpense: builder.mutation({
      query: ({
        agencyid,
        vendorid,
        description,
        exptype,
        expdate,
        amount,
      }) => ({
        url: "/Expenses/PostExpenses",
        method: "POST",
        body: { agencyid, vendorid, exptype, description, expdate, amount },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Saving expense...",
          success: "Expense saved successfully ✅",
          error: "Error saving expense ❌",
        });
      },
    }),

    getExpenseDetails: builder.query({
      query: ({ agencyid, fromdate, todate }) => {
        if (!fromdate && !todate) return;

        const params = new URLSearchParams({ agencyid });

        if (fromdate)
          params.append("fromdate", dayjs(fromdate).format("YYYY-MM-DD"));
        if (todate) params.append("todate", dayjs(todate).format("YYYY-MM-DD"));

        return {
          url: `/Expenses/GetExpensesDetail?${params.toString()}`,
          method: "GET",
        };
      },
    }),

    // ✅ Update Expense
    updateExpense: builder.mutation({
      query: ({
        id,
        vendorid,
        description,
        agencyid,
        exptype,
        expdate,
        amount,
      }) => ({
        url: `/Expenses/PutExpenses/${id}`,
        method: "POST",
        body: { agencyid, exptype, vendorid, description, expdate, amount },
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Updating expense...",
          success: "Expense updated successfully ✅",
          error: "Error updating expense ❌",
        });
      },
    }),

    deleteExpense: builder.mutation({
      query: (id) => ({
        url: `/Expenses/DeleteExpense/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        toast.promise(queryFulfilled, {
          pending: "Deleting expense...",
          success: "Expense deleted successfully ✅",
          error: "Error deleting expense ❌",
        });
      },
    }),

    getVendors: builder.query({
      query: (agencyid) => ({
        url: `/Vendors/GetVendor?agencyid=${agencyid}`,
        method: "GET",
      }),
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetExpenseTypesQuery,
  usePostExpenseMutation,
  useGetExpenseDetailsQuery,
  useLazyGetExpenseDetailsQuery,
  useUpdateExpenseMutation,
  useDeleteExpenseMutation,
  useGetVendorsQuery,
} = expensesApi;
